// extracted by mini-css-extract-plugin
export default {"authPage":"AuthPage_authPage__ZdF0E","inputField":"AuthPage_inputField__kmdpB","authTitle":"AuthPage_authTitle__HLNbK","authAdminTitle":"AuthPage_authAdminTitle__T6Ybs"};